import { Box } from "@mantine/core";

export interface DashedBorderProps {
  /** Orientation of the border */
  orientation?: "horizontal" | "vertical";
  /** Color of the border - defaults to gray.2 */
  color?: string;
  /** Dash array pattern - defaults to "4 6" */
  dashArray?: string;
  /** Stroke width - defaults to 1 */
  strokeWidth?: number;
  /** Additional styles */
  style?: React.CSSProperties;
  /** Additional className */
  className?: string;
}

export function DashedBorder({
  orientation = "horizontal",
  color = "var(--mantine-color-gray-4)",
  dashArray = "4 6",
  strokeWidth = 1,
  style,
  className,
  ...props
}: DashedBorderProps) {
  const isHorizontal = orientation === "horizontal";

  return (
    <Box
      component="svg"
      width={isHorizontal ? "100%" : strokeWidth}
      height={isHorizontal ? strokeWidth : "100%"}
      style={{
        display: "block",
        zIndex: 1,
        ...style,
      }}
      className={className}
      {...props}
    >
      <line
        x1={isHorizontal ? "0" : "0.5"}
        y1={isHorizontal ? "0.5" : "0"}
        x2={isHorizontal ? "100%" : "0.5"}
        y2={isHorizontal ? "0.5" : "100%"}
        stroke={color}
        strokeDasharray={dashArray}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
      />
    </Box>
  );
}
